import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/doubleQuotes.png'


const _hoisted_1 = { class: "natural_farming_recommend_content" }
const _hoisted_2 = { class: "natural_farming_recommend_boxs" }
const _hoisted_3 = { class: "natural_farming_recommend_box_theme" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "natural_farming_recommend_box_title" }
const _hoisted_6 = { class: "natural_farming_recommend_des_box" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "natural_farming_recommend_des_box_icon",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.info.list, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "natural_farming_recommend_box",
          key: item.theme
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(item.theme), 1),
          _createElementVNode("img", {
            class: "natural_farming_recommend_box_img",
            src: item.img
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.des, (desContent, index) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "natural_farming_recommend_des_box_content",
                key: index
              }, _toDisplayString(desContent), 1))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}